import { useEffect, useState } from "react";
import { useLocation, useOutlet } from "react-router-dom";

const TransitionRouter = () => {
  const location = useLocation();
  const outlet = useOutlet();

  const [displayedOutlet, setDisplayedOutlet] = useState(outlet);
  const [fadeState, setFadeState] = useState("fade-in");
  const [currentPath, setCurrentPath] = useState(location.pathname);

  useEffect(() => {
    if (location.pathname !== currentPath) {
      setFadeState("fade-out");

      const timeout = setTimeout(() => {
        setDisplayedOutlet(outlet);
        setFadeState("fade-in");
        setCurrentPath(location.pathname);
      }, 500);

      return () => clearTimeout(timeout);
    }
  }, [location, outlet, currentPath]);

  return <div className={`fade-wrapper ${fadeState}`}>{displayedOutlet}</div>;
};

export default TransitionRouter;
